import {Component, Input, ViewEncapsulation} from '@angular/core';
import {AppState} from "../../store/store";
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {Serializer} from "../../interfaces/serializer";
import {User} from "../../interfaces/user";
import {selectProfile, selectProfileModeLoading} from "../../store/profile/profile.selectors";
import {changeRealConversionsCorrectionMode} from "../../store/profile/profile.actions";
import {AppService} from "../../services/app.service";

@Component({
  selector: 'app-real-conversions-button',
  templateUrl: './real-conversions-button.component.html',
  styleUrls: ['./real-conversions-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RealConversionsButtonComponent {
  @Input() public disabled: boolean;

  protected _profile$: Observable<Serializer<User>> = this._store.select(selectProfile);
  public loading$: Observable<boolean> = this._store.select(selectProfileModeLoading);
  private realConversionsModes = [
    {
      level: 0,
      label: 'real_conversions.disabled',
      color: 'red'
    },
    {
      level: 3,
      label: 'real_conversions.post_click_view_correction_status',
      color: 'green'
    }
  ];

  constructor(
    private readonly _store: Store<AppState>,
    protected readonly appS: AppService
  ) {
  }

  public setRealConversions(mode: number): void {
    this._store.dispatch(changeRealConversionsCorrectionMode({mode: mode}));
  }

  public toggleRealConversions(): void {
    this._profile$.subscribe(profile => {
      const currentMode = profile.attributes.real_conversions_correction_mode;
      const newMode = currentMode === 0 ? 3 : 0;
      this.setRealConversions(newMode);
    }).unsubscribe();
  }

  public modeTo(elem: string, mode: number): string {
    if(mode !== 0 && mode !== 3) {
      mode = 3
    }
    const foundMode = this.realConversionsModes.find(real_conversions_mode => real_conversions_mode['level'] === mode);
    return foundMode[elem];
  }
}
